
define(
	'TavanoTeam.CategoryFacet.CategoryFacet'
,   [
		'TavanoTeam.CategoryFacet.CategoryFacet.View',
		'Facets.Browse.View.Extension',
		'Facets.FacetedNavigationItem.View.Extension',
		'Facets.FacetsDisplay.View.Extension',
		'Facets.Translator.Extension'
	]
,   function (
		CategoryFacetView,
		FacetsBrowseViewExtension,
		FacetsFacetedNavigationItemViewExtension,
		FacetsFacetsDisplayViewExtension,
		FacetsTranslatorExtension
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			
			var layout = container.getComponent('Layout');
			var categories_facets = [];
			var categoryTree = SC.CATEGORIES;
			var counter = 500;
			// For the first level, we want to show the "title" as a facet
			_.each(categoryTree,function(primaryCategory){
				var facet_element = {
					id : "cat_path_" + primaryCategory.internalid,
					name : primaryCategory.name,
					collapsed: true,
					priority: counter.toString()
					// template: "facets_faceted_navigation_item_categories_menu_tree_extension.tpl"
				}
				counter++;
				categories_facets.push(facet_element)
			})

			// For other categories, we only need to incude the cat_path_i for i = 1..Categories.length()

			for (var i = 1 ; i < 1000; i ++){
				categories_facets.push({
					id : "cat_path_" + i.toString(),
					collapsed: true
				})
				
			}
			
		// Add to the configuration record
			SC.CONFIGURATION.facets = SC.CONFIGURATION.facets.concat(categories_facets);

			// Add to the translator config
			container.translatorConfig.facets = container.translatorConfig.facets.concat(categories_facets)
			

		}
	};
});
